import {Injectable} from 'ng-metadata/core';
import {AbstractRequest} from './abstractRequest';
import {FormBuilderEnums} from '../../../../../../infra/formBuilder/formBuilder.service';
import { MappingTablesCache } from '../../../../../../mappingTablesCache/mappingTablesCache.service';
import { ConfigurationUtil } from '../../../../../../nddUtils/configurationUtil.service';

@Injectable()
export class PhotocopyRequest extends AbstractRequest {
	constructor(
		private mappingTablesCache : MappingTablesCache,
        private configurationUtil:ConfigurationUtil
	){
		super();
		//noinspection TypeScriptValidateTypes
		this.formFields = [
			{
				key: 'locations',
				name: 'pickup_location',
				path: 'ordered-locations',
				label: 'PhotocopyRequest.pickup_location',
				value: '',
				mandatory: true,
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
				populator:  {
					func:       this.itemsArrayPopulator.bind(this),
					params:     {
                        key: 'pickuplocationcode',
                        value:'pickuplocationname',
						byKey: 'field-name',
						byValue:'field-values'
					}
				}
			},
            {
                key: 'request_author',
                name: 'request_author',
                label: 'PhotocopyRequest.request_author',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'request_title',
                name: 'request_title',
                label: 'PhotocopyRequest.request_title',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'request_pages',
                name: 'request_pages',
                label: 'PhotocopyRequest.request_pages',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'patron_note_1',
                name: 'patron_note_1',
                label: 'PhotocopyRequest.patron_note_1',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'patron_note_2',
                name: 'patron_note_2',
                label: 'PhotocopyRequest.patron_note_2',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'requester_name',
                name: 'requester_name',
                label: 'PhotocopyRequest.requester_name',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'add_info',
                name: 'add_info',
                label: 'PhotocopyRequest.add_info',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
			{
				key: 'info-notes',
				name: 'info-notes',
				path: FormBuilderEnums.ROOT,
				label: 'PhotocopyRequest.patron_note_1',
				mandatory: false,
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.INTERNAL,
				uiType: FormBuilderEnums.UI_TYPE.MULTI_LABEL,
				populator:  {
					func:       this.itemsArrayPopulator.bind(this)
				}
			},
			{
				key: 'main_location',
				name: 'main_location',
				path: 'drop-downs/main_location',
				label: 'PhotocopyRequest.main_location',
				mandatory: true,
				dependOn: {key : 'info-notes', isExists : false},
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
				populator:  {
					func:       this.itemsArrayPopulator.bind(this),
					params:     {
						byKey: 'field-name',
						byValue:'field-values'
					}
				}
			},
			{
				key: 'item_description',
				name: 'item-description',
				path: 'drop-downs/item_description',
				label: 'PhotocopyRequest.item_description',
				mandatory: true,
				dependOn: {key : 'info-notes', isExists : false},
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
				populator:  {
					func:       this.itemsArrayPopulator.bind(this),
					params:     {
						byKey: 'field-name',
						byValue:'field-values'
					}
				}
			},
			{
				key: 'item_category_name',
				name: 'item-category',
				path: 'drop-downs/item_category',
				label: 'PhotocopyRequest.category',
				mandatory: false,
				dependOn: {key : 'info-notes', isExists : false},
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
				populator:  {
					func:       this.itemsArrayPopulator.bind(this),
					params:     {
						byKey: 'field-name',
						byValue:'field-values'
					}

				},

			},
			{
				key: 'item_status_name',
				name: 'item-status-name',
				path: 'drop-downs/item_status',
				label: 'PhotocopyRequest.item_status',
				mandatory: true,
				dependOn: {key : 'info-notes', isExists : false},
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
				populator:  {
					func:       this.itemsArrayPopulator.bind(this),
					params:     {
						byKey: 'field-name',
						byValue:'field-values'
					}
				}
			}
		];
	}
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/photocopyRequest.ts